shvenergy.utils = (function ($) {
	"use strict";

	const breakpoints = [
		"small: 0",
		"medium: 640",
		"large: 1024",
		"xlarge: 1200",
		"xxlarge: 1366",
		"xxxlarge: 1920"
	];

	const breakpointsObj = {
		small: 0,
		medium: 640,
		large: 1024,
		xlarge: 1200,
		xxlarge: 1366,
		xxxlarge: 1920
	};

	function isMobile() {

		return window.matchMedia("(max-width: 640px)").matches;

    }

    function hideOverlay() {
        $("html").addClass("removeoverlay");
        setTimeout(function () {
	        $("html").removeClass("removeoverlay show-overlay");
        }, 300);
	}

	function getUrlParameter(name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
		const results = regex.exec(location.search);
		return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	function validateEmail(email) {
		const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i;
		return re.test(email.toLowerCase());
	}

	return {
		isMobile: isMobile,
		breakpoints: breakpoints,
		breakpointsObj: breakpointsObj,
		hideOverlay: hideOverlay,
		getUrlParameter: getUrlParameter,
		validateEmail: validateEmail
	};

})(jQuery);